<template>
  <d-modal
    :modal="modal"
    :title="$t('logs.details.page-heading')"
    @closeModal="handleCloseModal"
    maxWidth="800px"
    :hideSubmitButton="true"
  >
    <template slot="body">
      <v-row>
        <v-col cols="12" class="mb-3">
          <v-row align="center">
            <v-col cols="auto">
              <v-avatar :title="item?.actionByUser" size="48" color="primary">
                <span class="white--text subtitle-1">
                  {{ item?.actionByUser?.charAt(0)?.toUpperCase() }}</span
                ></v-avatar
              >
            </v-col>
            <v-col>
              <div class="mb-1 body-1" v-html="item.description"></div>
              <p class="mb-0 body-2">
                {{ formatDate(item.logDateTime, "dd.MM.yyyy HH:mm") }}
              </p>
            </v-col>
          </v-row>
        </v-col>

        <v-col
          cols="12"
          class="mb-3 pt-3 border-top"
          v-for="changeLog in item.changeLogDatas"
          :key="changeLog.fieldName"
        >
          <p class="mb-1">
            <strong>{{ changeLog.fieldName }}</strong>
          </p>

          <div class="d-flex align-center">
            <span>{{ changeLog.oldValue || "—" }}</span>
            <v-icon class="mx-2">mdi-arrow-right</v-icon>
            <span>{{ changeLog.newValue }}</span>
          </div>
        </v-col>
      </v-row>
    </template>
  </d-modal>
</template>
    
    <script>
export default {
  setup() {},

  props: {
    modal: {
      type: Boolean,
      default: false,
    },
    item: Object,
  },
  data() {
    return {};
  },
  methods: {
    handleCloseModal() {
      this.$emit("closeModal");
    },
  },
};
</script>
    